import { render, staticRenderFns } from "./TermBox.vue?vue&type=template&id=31f78e0a&scoped=true&"
import script from "./TermBox.vue?vue&type=script&lang=js&"
export * from "./TermBox.vue?vue&type=script&lang=js&"
import style0 from "./TermBox.vue?vue&type=style&index=0&id=31f78e0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f78e0a",
  null
  
)

export default component.exports